import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/huBei/u183.png'
import _imports_1 from '@/assets/image/huBei/tb.png'
import _imports_2 from '@/assets/image/huBei/jian.png'
import _imports_3 from '@/assets/image/huBei/jia.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-31b2f911")

_pushScopeId("data-v-31b2f911")
const _hoisted_1 = { class: "service-detail-container" }
const _hoisted_2 = { class: "details" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "banner" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "title" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createVNode("span", null, "投保说明")
], -1)
const _hoisted_5 = { class: "desc" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { class: "desc-tag" }, "1"),
  /*#__PURE__*/_createVNode("span", { class: "desc-title" }, "试算保费并查看保障范围")
], -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("去试算")
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("span", { class: "desc-tag" }, "2"),
    /*#__PURE__*/_createVNode("span", { class: "desc-title" }, "请填写个人信息")
  ]),
  /*#__PURE__*/_createVNode("p", null, "请点击底部\"填写信息\"按钮提交您的信息")
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("span", { class: "desc-tag" }, "3"),
    /*#__PURE__*/_createVNode("span", { class: "desc-title" }, "业务员联系投保")
  ]),
  /*#__PURE__*/_createVNode("p", null, "收到您的投保意愿后，我们的业务员将主动联系您，为您进行投保")
], -1)
const _hoisted_10 = { class: "footer" }
const _hoisted_11 = { class: "btn-box" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "write-btn" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("填写信息")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("已提交")
const _hoisted_16 = { class: "popup-content" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = { class: "auth-box" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "label" }, "服务授权", -1)
const _hoisted_20 = { class: "protocol" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("同意 ")
const _hoisted_22 = /*#__PURE__*/_createVNode("span", null, "授权使用本人补充医疗保险账户额度 ", -1)
const _hoisted_23 = { class: "btn-box" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("再想想")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("确认提交")
const _hoisted_26 = { class: "item" }
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "label" }, "姓名", -1)
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "item" }
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "label" }, "手机号", -1)
const _hoisted_31 = { class: "value" }
const _hoisted_32 = { class: "item" }
const _hoisted_33 = /*#__PURE__*/_createVNode("span", { class: "label" }, "身份证号", -1)
const _hoisted_34 = { class: "value" }
const _hoisted_35 = { class: "item" }
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "label" }, "家庭地址", -1)
const _hoisted_37 = { class: "value" }
const _hoisted_38 = { class: "item auth-box" }
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { class: "label" }, "服务授权", -1)
const _hoisted_40 = { class: "protocol" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("同意 ")
const _hoisted_42 = /*#__PURE__*/_createVNode("span", null, "授权使用本人补充医疗保险账户额度 ", -1)
const _hoisted_43 = {
  key: 0,
  class: "salesman-box"
}
const _hoisted_44 = /*#__PURE__*/_createVNode("span", { class: "salesman-desc" }, "您有任何疑问，可联系专属业务员", -1)
const _hoisted_45 = { class: "salesman-info" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("拨打电话")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_field = _resolveComponent("van-field")
  const _component_van_checkbox = _resolveComponent("van-checkbox")
  const _component_van_form = _resolveComponent("van-form")
  const _component_van_popup = _resolveComponent("van-popup")
  const _component_van_area = _resolveComponent("van-area")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("div", null, [
          _createVNode(_component_van_button, {
            type: "primary",
            plain: "",
            onClick: _ctx.jumpTo
          }, {
            default: _withId(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _hoisted_8,
      _hoisted_9
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("div", _hoisted_11, [
        (!_ctx.submitStatus)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode("img", {
                src: _imports_2,
                alt: "",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.increase && _ctx.increase(...args)))
              }),
              _createVNode("span", null, _toDisplayString(_ctx.form.servingCount), 1),
              _createVNode("img", {
                src: _imports_3,
                alt: "",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.subtract && _ctx.subtract(...args)))
              })
            ], 64))
          : (_openBlock(), _createBlock("span", _hoisted_12, "共" + _toDisplayString(_ctx.form.servingCount) + "份", 1))
      ]),
      _createVNode("div", _hoisted_13, [
        (!_ctx.submitStatus)
          ? (_openBlock(), _createBlock(_component_van_button, {
              key: 0,
              type: "primary",
              plain: "",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.show = true))
            }, {
              default: _withId(() => [
                _hoisted_14
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_van_button, {
              key: 1,
              class: "btn-success",
              plain: "",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showSuccess = true))
            }, {
              default: _withId(() => [
                _hoisted_15
              ]),
              _: 1
            }))
      ])
    ]),
    _createVNode(_component_van_popup, {
      class: "write-popup",
      show: _ctx.show,
      "onUpdate:show": _cache[14] || (_cache[14] = ($event: any) => (_ctx.show = $event))
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_16, [
          _createVNode(_component_van_form, { onSubmit: _ctx.onSubmit }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_17, [
                _createVNode(_component_van_field, {
                  modelValue: _ctx.form.userName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.userName = $event)),
                  label: "姓名",
                  placeholder: "请填写姓名",
                  rules: [{ required: true, message: '姓名不能为空' }]
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  modelValue: _ctx.form.phone,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.phone = $event)),
                  type: "tel",
                  label: "手机号",
                  placeholder: "请填写手机号",
                  rules: [
                { required: true, message: '手机号不能为空' },
                { validator: _ctx.validatorTel }
              ]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_van_field, {
                  modelValue: _ctx.form.identityCard,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.identityCard = $event)),
                  label: "身份证号",
                  placeholder: "请填写身份证号",
                  rules: [
                { required: true, message: '身份证号不能为空' },
                { validator: _ctx.validatorIdCard }
              ]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_van_field, {
                  modelValue: _ctx.form.addString,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.addString = $event)),
                  label: "所在地区",
                  placeholder: "请选择省市区",
                  rules: [
                {
                  required: true,
                  trigger: 'onChange',
                  message: '省市区不能为空'
                }
              ],
                  onClick: _ctx.onClickAdditem
                }, null, 8, ["modelValue", "onClick"]),
                _createVNode(_component_van_field, {
                  modelValue: _ctx.form.address,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.address = $event)),
                  label: "详细地址",
                  placeholder: "街道、楼牌号等",
                  rules: [{ required: true, message: '详细地址不能为空' }]
                }, null, 8, ["modelValue"]),
                _createVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode("div", _hoisted_20, [
                    _createVNode("div", null, [
                      _createVNode(_component_van_checkbox, {
                        modelValue: _ctx.userChecked,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.userChecked = $event)),
                        shape: "square",
                        "icon-size": "14",
                        "checked-color": "#FF931F"
                      }, null, 8, ["modelValue"]),
                      _hoisted_21,
                      _createVNode("span", {
                        class: "auth",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toUserAuth('writePopup')))
                      }, "《普康宝用户协议》")
                    ]),
                    _createVNode("div", null, [
                      _createVNode(_component_van_checkbox, {
                        modelValue: _ctx.authChecked,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.authChecked = $event)),
                        shape: "square",
                        "icon-size": "14",
                        "checked-color": "#FF931F"
                      }, null, 8, ["modelValue"]),
                      _hoisted_22
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_23, [
                _createVNode(_component_van_button, {
                  class: "cancel-btn",
                  plain: "",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.show = false))
                }, {
                  default: _withId(() => [
                    _hoisted_24
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_button, {
                  class: "submit-btn",
                  type: "primary",
                  "native-type": "submit",
                  plain: ""
                }, {
                  default: _withId(() => [
                    _hoisted_25
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      class: "view-popup",
      show: _ctx.showSuccess,
      "onUpdate:show": _cache[18] || (_cache[18] = ($event: any) => (_ctx.showSuccess = $event))
    }, {
      default: _withId(() => [
        _createVNode("div", null, [
          _createVNode("div", _hoisted_26, [
            _hoisted_27,
            _createVNode("div", _hoisted_28, _toDisplayString(_ctx.form.userName), 1)
          ]),
          _createVNode("div", _hoisted_29, [
            _hoisted_30,
            _createVNode("div", _hoisted_31, _toDisplayString(_ctx.form.phone), 1)
          ]),
          _createVNode("div", _hoisted_32, [
            _hoisted_33,
            _createVNode("div", _hoisted_34, _toDisplayString(_ctx.form.identityCard), 1)
          ]),
          _createVNode("div", _hoisted_35, [
            _hoisted_36,
            _createVNode("div", _hoisted_37, _toDisplayString(_ctx.form.province + _ctx.form.city + _ctx.form.district + _ctx.form.address), 1)
          ]),
          _createVNode("div", _hoisted_38, [
            _hoisted_39,
            _createVNode("div", _hoisted_40, [
              _createVNode("div", null, [
                _createVNode(_component_van_checkbox, {
                  modelValue: _ctx.checked,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.checked = $event)),
                  shape: "square",
                  "icon-size": "14",
                  "checked-color": "#FF931F",
                  disabled: ""
                }, null, 8, ["modelValue"]),
                _hoisted_41,
                _createVNode("span", {
                  class: "auth",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.toUserAuth('viewPopup')))
                }, "《普康宝用户协议》")
              ]),
              _createVNode("div", null, [
                _createVNode(_component_van_checkbox, {
                  modelValue: _ctx.checked,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.checked = $event)),
                  shape: "square",
                  "icon-size": "14",
                  "checked-color": "#FF931F",
                  disabled: ""
                }, null, 8, ["modelValue"]),
                _hoisted_42
              ])
            ])
          ]),
          (_ctx.form.salesmanName && _ctx.form.salesmanPhone)
            ? (_openBlock(), _createBlock("div", _hoisted_43, [
                _hoisted_44,
                _createVNode("div", _hoisted_45, [
                  _createVNode("span", null, _toDisplayString(_ctx.form.salesmanName), 1),
                  _createVNode("span", null, [
                    _createVNode("span", null, _toDisplayString(_ctx.form.salesmanPhone), 1),
                    _createVNode(_component_van_button, {
                      type: "primary",
                      size: "mini",
                      plain: "",
                      onClick: _ctx.callPhone
                    }, {
                      default: _withId(() => [
                        _hoisted_46
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      position: "bottom",
      show: _ctx.selectAddr,
      "onUpdate:show": _cache[20] || (_cache[20] = ($event: any) => (_ctx.selectAddr = $event))
    }, {
      default: _withId(() => [
        _createVNode(_component_van_area, {
          title: "选择省市区",
          "area-list": _ctx.areaList,
          onCancel: _cache[19] || (_cache[19] = ($event: any) => (_ctx.selectAddr = false)),
          onConfirm: _ctx.confirmAddr
        }, null, 8, ["area-list", "onConfirm"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
})